import { BRAND_NAME } from "@/lib/brand";
import {
  COMPANY_ADDRESS,
  COMPANY_BRAND_NAME,
  COMPANY_GEO,
} from "@/lib/brand/organization";

export const DEFAULT_CONTACTS_HERO = {
  sectionId: "contacts-hero",
  title: "О компании и контакты",
  lead: `Сервис ${BRAND_NAME} разработан и поддерживается ${COMPANY_BRAND_NAME} — платиновым партнёром Битрикс24. Ниже — контакты, адрес и ссылки на юридические документы.`,
  mapFollows: true,
};

export const DEFAULT_YANDEX_MAP = {
  sectionId: "contacts-map",
  lat: COMPANY_GEO.lat,
  lon: COMPANY_GEO.lon,
  zoom: 17,
  heightPx: 420,
  addressLabel: COMPANY_ADDRESS.formatted,
  layout: "hero" as const,
  widthMode: "full" as const,
  showAddress: true,
};
